import React, { useRef, useState } from 'react';
import './stepper.sass';
import { Marker } from '../marker/marker';
import { Button, ButtonSize, ButtonType } from '../../../../components/interface/button/button';
import ArrowRight from '../../assets/Arrow_right.png';

export const Stepper = ({children}) => {

    const [currentIndex, setCurrentIndex] = useState(0);

    const childrenRef = useRef([]);

    const handleNext = () => {
        if (currentIndex <= children.length - 1)
        {
            childrenRef.current[currentIndex].start();
        }
    };

    const onSuccess = () => {
        if (currentIndex <= children.length -1) {
            setCurrentIndex(currentIndex + 1);
        }
    };

    return (
        <div className='vv-vendor-stepper-container'>
            <div className='vv-vendor-stepper'>
                <div className='vv-vendor-stepper__headline'>
                    <h3>Konfigurowanie konta</h3>
                    <p>Prosta konfiguracja w 3 krokach</p>
                </div>
                <div className='vv-vendor-stepper__marker-container'>
                    <Marker text='Profil usługi' number={1} isActive={currentIndex === 0}/>
                    <div className='marker-dash'/>
                    <Marker text='Faktury i finanse' number={2} isActive={currentIndex === 1}/>
                    <div className='marker-dash'/>
                    <Marker text='Zaproszenie do aplikacji' number={3} isActive={currentIndex === 2}/>
                </div>
                {
                    React.cloneElement(children[currentIndex], {ref: (ref) => {
                        childrenRef.current[currentIndex] = ref;
                        }, onSuccess})
                }
                <div className='vv-vendor-stepper__button-container'>
                    <Button text='DALEJ' size={ButtonSize.VENDOR} buttonType={ButtonType.BLACK} onClick={handleNext} iconRight={ArrowRight}/>
                </div>
            </div>
        </div>
    );
};